import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/leads_/details/$leadId/bank-request/')({
    beforeLoad: ({ params }) => {
        throw redirect({
            params,
            replace: true,
            search: true,
            to: '/leads/details/$leadId/bank-request/new-request',
        });
    },
});
